import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import App from "./App";
import { queryClient } from "@/lib/queryClient";
import { initSentry, SentryErrorBoundary } from "@/lib/sentry";
import { ThemeProvider } from "@/stores/theme";
import "@/i18n";
import "./index.css";

initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<FallbackError />}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <BrowserRouter>
            <App />
            <Toaster
              position="top-center"
              richColors
              closeButton
              theme="system"
              toastOptions={{ className: "font-sans" }}
            />
          </BrowserRouter>
        </ThemeProvider>
      </QueryClientProvider>
    </SentryErrorBoundary>
  </React.StrictMode>
);

function FallbackError() {
  return (
    <div className="flex min-h-screen items-center justify-center p-6 text-center">
      <div>
        <p className="text-2xl font-bold mb-2">Oups</p>
        <p className="text-muted-foreground mb-4">
          Une erreur s'est produite. Recharge la page pour réessayer.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="rounded-lg bg-primary text-primary-foreground px-4 py-2 font-semibold"
        >
          Recharger
        </button>
      </div>
    </div>
  );
}
